module.exports={
  "show": {
    "tooltipOn": "Show tooltip on",
    "slider": "Show slider",
    "more": "Show more",
    "infoBubbleOnHover": "Show info bubble on hover",
    "infoBubbleOnClick": "Show info bubble on click",
    "autoAdjustMenu": "Show auto adjust menu",
    "filteringDataLimit": "Show limit for filtering data"
  },
  "hide": {
    "slider": "Hide slider",
    "hint": "Hide hint",
    "autoAdjustMenu": "Hide auto adjust menu",
    "filteringDataLimit": "Hide limit for filtering data"
  }
}
